<template>
  <el-dialog
    :visible.sync="visible"
    width="1400px"
    @close="handleCancel"
    :title="title"
  >
    <div class="add-standard">
      <div class="add-standard__form">
        <el-form
          :model="form"
          ref="form"
          label-position="right"
          label-width="80px"
          :rules="rules"
          inline
        >
          <el-form-item label="标准名称" prop="standardName">
            <el-input
              v-model="form.standardName"
              style="width: 300px"
              placeholder="请输入标准名称"
            />
          </el-form-item>
          <el-form-item label="设备类型" prop="deviceType">
            <el-select v-model="form.deviceType" placeholder="请选择">
              <el-option
                v-for="item in deviceTypeList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="备注">
            <el-input
              v-model="form.standardRemarks"
              style="width: 300px"
              placeholder="请输入备注"
            />
          </el-form-item>
        </el-form>
      </div>
      <div class="add-standard__opt">
        <el-button type="primary" @click="handleAdd">新增</el-button>
      </div>
      <div class="add-standard__table">
        <el-table ref="itemTable" :data="tableData" height="100%">
          <el-table-column prop="itemName" label="项目名称" align="center">
            <template slot-scope="scope">
              <el-input v-model="scope.row.itemName" placeholder="巡检项名称" />
            </template>
          </el-table-column>
          <el-table-column label="单位" align="center">
            <template slot-scope="scope">
              <el-input v-model="scope.row.itemUnit" placeholder="巡检项单位" />
            </template>
          </el-table-column>
          <el-table-column label="记录方式" align="center">
            <template slot-scope="scope">
              <el-select v-model="scope.row.showType" placeholder="请选择">
                <el-option
                  v-for="item in recordMethodList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column label="正常值/上限" align="center">
            <template slot-scope="scope">
              <el-input
                v-model="scope.row.upValue"
                placeholder="多选用,隔开"
                v-if="scope.row.showType !== '3' && scope.row.showType !== ''"
              />
            </template>
          </el-table-column>
          <el-table-column label="异常值/下限" align="center">
            <template slot-scope="scope">
              <el-input
                v-model="scope.row.downValue"
                placeholder="多选用,隔开"
                v-if="scope.row.showType !== '3' && scope.row.showType !== ''"
              />
            </template>
          </el-table-column>
          <el-table-column label="默认值" align="center">
            <template slot-scope="scope">
              <el-input
                v-model="scope.row.defaultValue"
                placeholder="巡检项默认值"
              />
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center">
            <template slot-scope="scope">
              <el-tooltip effect="dark" content="下移" placement="top-start">
                <i
                  class="item-operation-icon iconfont el-icon-download icon-blue"
                  @click="moveDown(scope.row, scope.$index)"
                ></i>
              </el-tooltip>
              <el-tooltip effect="dark" content="上移" placement="top-start">
                <i
                  class="item-operation-icon el-icon-upload2 icon-blue"
                  @click="moveUp(scope.row, scope.$index)"
                ></i>
              </el-tooltip>
              <el-tooltip effect="dark" content="删除" placement="top-start">
                <i
                  class="item-operation-icon el-icon-delete icon-blue"
                  @click="handleDelete(scope.row, scope.$index)"
                ></i>
              </el-tooltip>
            </template>
          </el-table-column>
          <template slot="empty">
            <div class="el-table__empty-block">
              <span class="el-table__empty-text">
                <div class="ioc-crud__empty">
                  <div class="ioc-empty">
                    <div class="ioc-empty__image" style="height: 50px">
                      <img src="../img/empty.svg" alt="" />
                    </div>
                    <p class="ioc-empty__desc">暂无数据</p>
                  </div>
                </div>
              </span>
            </div>
          </template>
        </el-table>
      </div>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button type="primary" @click="handleAddOrUpdate">确 定</el-button>
      <el-button @click="handleCancel">取 消</el-button>
    </div>
  </el-dialog>
</template>

<script>
import api from "../api/index";
export default {
  name: "addStandardComponent",
  props: {
    title: {
      type: String,
      default: "",
    },
    form: {
      type: Object,
      default: {},
    },
    deviceTypeList: {
      type: Array,
      default: [],
    },
    standItemList: {
      type: Array,
      default: [],
    },
  },
  watch: {
    standItemList: {
      handler(val) {
        console.log("巡检项", val);
        this.tableData = val;
      },
      deep: true,
      immediate: true,
    },
  },
  data() {
    return {
      rules: {
        standardName: [
          {
            required: true,
            message: "标准名称必填",
            trigger: "blur",
          },
        ],
        deviceType: [
          {
            required: true,
            message: "标准名称必填",
            trigger: "blur",
          },
        ],
      },
      visible: false,
      recordMethodList: [
        {
          label: "单选",
          value: "0",
        },
        {
          label: "多选",
          value: "1",
        },
        {
          label: "数值",
          value: "2",
        },
        {
          label: "文本",
          value: "3",
        },
      ],
      tableColumns: [
        {
          label: "项目名称",
          prop: "itemName",
        },
        {
          label: "单位",
          prop: "itemUnit",
        },
        {
          label: "记录方式",
          prop: "showType",
        },
        {
          label: "正常值/上限",
          prop: "upValue",
        },
        {
          label: "异常值/下限",
          prop: "downValue",
        },
        {
          label: "默认值",
          prop: "defaultValue",
        },
        {
          label: "操作",
          prop: "operating",
          width: 100,
        },
      ],
      tableData: [
        {
          entryName: "",
          unit: "",
          recordMethod: "",
          upperLimit: "",
          lowerLimit: "",
          default: "",
        },
      ],
    };
  },
  mounted() {
    this.visible = true;
  },
  methods: {
    handleDelete(row, index) {
      this.tableData.splice(index, 1);
    },
    moveUp(row, index) {
      if (index === 0) {
        return;
      }
      const arr = this.tableData;
      const oneRow = arr[index - 1];
      arr[index - 1] = arr[index];
      arr[index] = oneRow;
      this.tableData = JSON.parse(JSON.stringify(arr));
    },
    moveDown(row, index) {
      if (index === this.tableData.length - 1) {
        return;
      }
      const arr = this.tableData;
      const oneRow = arr[index + 1];
      arr[index + 1] = arr[index];
      arr[index] = oneRow;
      this.tableData = JSON.parse(JSON.stringify(arr));
    },
    handleAdd() {
      this.tableData.push({
        itemName: "",
        itemUnit: "",
        showType: "",
        upValue: "",
        downValue: "",
        defaultValue: "",
      });
    },
    handleCancel() {
      this.$emit("handleCancel");
    },
    handleAddOrUpdate() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          let param = {
            type: this.title == "新增巡检标准" ? "add" : "edit",
            standardInfo: this.form,
            getStandardItemList: this.standItemList,
          };
          this.$emit("handleConfirm", param);
        }
      });
    },
  },
};
</script>

<style lang='scss' scoped>
.add-standard {
  display: flex;
  flex-direction: column;
  height: 600px;
  .item-operation-icon {
    font-size: 14px;
    cursor: pointer;
    margin: 0 8px;
  }

  &__form {
    display: flex;
    flex-wrap: wrap;
  }

  &__opt {
    margin-bottom: 15px;
  }

  &__table {
    flex: 1;
    height: 0;
    display: flex;
    flex-direction: column;
    overflow-x: hidden;
    overflow-y: auto;
  }

  .operating {
    display: flex;
    align-items: center;
    .options_icon {
      cursor: pointer;
      margin-right: 10px;
    }

    .iconDelete {
      font-size: 12px;
    }
  }
}
</style>
